<template>
  <LibraryListItem>
    <div class="document-title text-textDarkest">
      {{ title }}
    </div>

    <BasicCellWithTooltip :text="jobLevel" />
    <BasicCellWithTooltip :text="language" />
    <BasicCellWithTooltip :text="lastRevisedAt" />
    <BasicCellWithTooltip :text="notes" />
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import BasicCellWithTooltip from '@/components/jobProfiles/profileListItemCells/BasicCellWithTooltip.vue';

const props = defineProps({
  ulid: { type: String, default: '' },
  title: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
  language: { type: String, default: '' },
  lastRevised: { type: String, default: '' },
  notes: { type: String, default: '' },
});

const lastRevisedAt = computed(
  () => (props.lastRevised ? new Date(props.lastRevised).toLocaleDateString('en-US') : ''),
);
</script>

<style lang="less" scoped>
.document-title {
  font-size: 15px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
